<svelte:head>
    <script type="text/javascript" src="https://www.sportident.com/web-components/mar/latest/package.min.js"></script>
    <link rel="stylesheet" href="https://www.sportident.com/web-components/mar/latest/styles.css" />
</svelte:head>

<div class="container">
    <si-battery-check></si-battery-check>
</div>
